import React from 'react';
import './Modal.css';

const Modal = ({ isOpen, onClose, title, children, autoClose = true }) => {
  return (
    <div 
      className={`modal ${isOpen ? 'show' : ''}`}
      style={{ 
        display: isOpen ? 'block' : 'none',
        backgroundColor: 'rgba(0,0,0,0.5)'
      }}
      onClick={autoClose ? onClose : undefined}
    >
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>
          <div className="modal-body p-0">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal; 